import React from 'react';
import Notifications from 'react-notify-toast';

const ToastNotifications = () =>
    <Notifications/>;

export default ToastNotifications;